export const FIELDS = {

  ID: 'id',
  NAME: 'name',
  SYNC_TOKEN: 'syncToken',
  ACCT_NUM: 'acctNum',
  CURRENCY_REF_NAME: 'currencyRefName',
  CURRENCY_REF_VALUE: 'currencyRefValue',
  DESCRIPTION: 'description',
  ACTIVE: 'active',
  SUB_ACCOUNT: 'subAccount',
  CLASSIFICATION: 'classification',
  FULLY_QUALIFIED_NAME: 'fullyQualifiedName',
  TXN_LOCATION_TYPE: 'txnLocationType',
  ACCOUNT_TYPE: 'accountType',
  CURRENT_BALANCE_WITH_SUB_ACCOUNTS: 'currentBalanceWithSubAccounts',
  ACCOUNT_ALIAS: 'accountAlias',
  ACCOUNT_SUB_TYPE: 'accountSubType',
  CURRENT_BALANCE: 'currentBalance',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
};